import { normalizeThreadSandboxMode } from '@/lib/pieveComposerSettings.js';
import getThreadsById from '@/lib/threads/getThreadsById.js';
import upsertSortedThread from '@/lib/threads/upsertSortedThread.js';

const applyThreadSandboxModeMutation = ({ state, threadId, sandboxMode, updatedAt }) => {
  if (!threadId) {
    return state;
  }

  const existingMeta = getThreadsById(state.threads)?.[threadId];

  if (!existingMeta) {
    return state;
  }

  const nextSandboxMode = normalizeThreadSandboxMode(sandboxMode || existingMeta?.sandboxMode);
  const nextUpdatedAt = updatedAt || existingMeta.updatedAt || new Date().toISOString();
  const nextThreadMeta = {
    ...existingMeta,
    sandboxMode: nextSandboxMode,
    updatedAt: nextUpdatedAt
  };

  return {
    ...state,
    threads: upsertSortedThread(state.threads, nextThreadMeta)
  };
};

export default applyThreadSandboxModeMutation;
